import { PopupMessageService } from "./../../../shared/message/services/message.service";
import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material";
import { Subscription } from "rxjs";
import { LocalService } from "src/app/core";
import { CreatePromotionService } from "src/app/core/services/create-promotion.service";
import * as XLSX from "xlsx";
import { ConfirmationDialogSubmitPromo } from "./confirmation-dialog-submit-promo";

@Component({
  selector: "app-create-promotions",
  templateUrl: "./create-promotions.component.html",
  styleUrls: ["./create-promotions.component.scss"],
})
export class CreatePromotionsComponent implements OnInit {
  pageno!: number;
  questionType!: string;
  promotionCreationIncomplete: boolean = true;
  initialAnsweredQues!: number;
  @HostListener("window:beforeunload", ["$event"])
  OnBeforeUnloadEventHandler($event: any): void {
    if (this.promotionCreationIncomplete) {
      $event.returnValue = "";
      return;
    }
  }
  @Output() promoCompleteStatusEvent = new EventEmitter<boolean>();
  @Output() promoSubmittedStatusEvent = new EventEmitter<boolean>();
  @ViewChild("fileInput") fileInput: any;
  combinedQuestionList: any = [];
  progressVal: number = 0;
  userData: any;
  private subs: Subscription[] = [];
  selectedFieldList: any;
  possibleValuesList: any;
  customConfigData: any;
  budgetCapAmtForRegions: any = {};
  budgetCapAmtMain: any = [];
  dynamicQuestionIndex!: number;
  incentiveAndPayoutQuestions: any = [];
  promotionEditOrCopy: boolean = false;
  inEligibleCountryValidated: boolean = true;
  passiveRecipientEmailVal: any;
  passiveRecipientEmailData: any;
  passiveEmailValidation: boolean = false;
  disableSaveButton: boolean = false;
  dropdownSettings: any = {};
  showSpinner: boolean = false;

  constructor(
    private createPromotionService: CreatePromotionService,
    private dialog: MatDialog,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnInit() {
    this.subs.push(
      this.createPromotionService.getCiscoAdminData().subscribe((data: any) => {
        this.promotionEditOrCopy = data.editData || false;
      }),
      this.createPromotionService
        .getCreationPromotionData()
        .subscribe((result: any) => {
          this.possibleValuesList = result.possibleValues;
          this.customConfigData = result.customChallenge;
          this.combinedQuestionList = result.questions;
          //console.log(this.combinedQuestionList);
          this.setInitialQuestion();
          if (this.promotionEditOrCopy) {
            this.progressVal = Math.ceil(
              (this.combinedQuestionList.length /
                this.combinedQuestionList.length) *
                100
            );
          } else {
            this.progressVal = Math.ceil(
              (this.initialAnsweredQues /
                (this.combinedQuestionList.length - 1)) *
                100
            );
          }
          this.userData = LocalService.get("userProfile");
          this.setCountryIncludeExcludeData();
        })
    );
    this.dropdownSettings = {
      singleSelection: false,
      idField: "value",
      textField: "label",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      maxHeight: 200,
      noDataAvailablePlaceholderText: "No selections made.",
    };
  }

  setInitialQuestion() {
    this.setBudgetAnswers();
    this.setQuestionNumbers();
    let criteria = this.combinedQuestionList[0];
    this.pageno = this.combinedQuestionList.indexOf(criteria);
    this.initialAnsweredQues = this.combinedQuestionList.indexOf(criteria);
    this.getQuestionContents();
  }

  setBudgetAnswers() {
    if (this.customConfigData.budgetCaps.length > 0) {
      this.customConfigData.budgetCaps.forEach((el: any) => {
        if (el.customBudgetCapType === "BUDGETCAP_REGIONAL") {
          this.budgetCapAmtForRegions[el.region] = el.amount;
        } else {
          this.budgetCapAmtMain[el.customBudgetCapType] = el.amount;
        }
      });
    }
  }

  setQuestionNumbers() {
    let questionNumber = 1;
    this.combinedQuestionList.forEach((question: any) => {
      if (
        question.identifier !== "TEMPLATED_PAYOUT" &&
        question.identifier !== "MAX_PAYOUT_PER_PO" &&
        question.identifier !== "MAX_PAYOUT_PER_CLAIM"
      ) {
        return (question.questionNumber = questionNumber++);
      }
    });
  }

  updateBudgetRegionSelection() {
    let budgetCapGroups: any = {};
    if (
      this.combinedQuestionList[this.pageno].formFieldType == "CHECKBOX" &&
      this.combinedQuestionList[this.pageno].identifier == "regions"
    ) {
      if (
        this.customConfigData[this.combinedQuestionList[this.pageno].identifier]
          .length
      ) {
        this.customConfigData[
          this.combinedQuestionList[this.pageno].identifier
        ].forEach((region: any) => {
          budgetCapGroups[region] = this.budgetCapAmtForRegions[region] || null;
        });
      }
      this.budgetCapAmtForRegions = budgetCapGroups;
    }
    if (this.customConfigData.budgetCaps.length > 0) {
      let updatedBudgetCaps = this.customConfigData.budgetCaps.filter(
        (budget: any) => {
          if (budget.customBudgetCapType === "BUDGETCAP_REGIONAL") {
            return Object.keys(this.budgetCapAmtForRegions).includes(
              budget.region
            );
          } else {
            return budget;
          }
        }
      );
      this.customConfigData.budgetCaps = updatedBudgetCaps;
    }
  }

  getQuestionContents(finalPage?: any) {
    if (finalPage) {
      this.questionType = "finalReview";
      return;
    }
    let fieldType = this.combinedQuestionList[this.pageno].identifier;
    if (fieldType == "regions") {
      fieldType = fieldType.toUpperCase();
    }
    this.selectedFieldList =
      fieldType != null ? this.possibleValuesList[fieldType] : null;
    if (fieldType == "quarter") {
      this.possibleValuesList.fiscalYear.forEach((data: any) => {
        if (data.value == this.customConfigData.fiscalYear) {
          this.selectedFieldList = data.possibleValues;
        }
      });
    }
    if (fieldType === "COUNTRY_INCLUDE" || fieldType === "COUNTRY_EXCLUDE") {
      let dropdownData: any[] = [];
      this.possibleValuesList.REGION_COUNTRY_MAPPING.forEach((regionData: any) => {
        this.customConfigData["regions"].forEach((region: any) => {
          if (region === regionData.value) {
            dropdownData = [...dropdownData, ...regionData.possibleValues];
          }
        });
      });
      this.selectedFieldList = dropdownData;
    }
   
    if (fieldType == "TRAINING_ACTIVITY") {
      this.showSpinner = true;
      let startDate = new Date(this.customConfigData["startDate"]);
      let endDate = new Date(this.customConfigData["endDate"]);
      let formattedStartDate =
        startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);
      let formattedEndDate =
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2);
      let regions = this.customConfigData["regions"];
      //console.log(this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex])
      this.subs.push(
        this.createPromotionService
          .getTrainingActivityData(
            formattedStartDate,
            formattedEndDate,
            regions
          )
          .subscribe(
            (data: any) => {
              this.selectedFieldList = data.ACTIVITY_CHALLENGES;
              this.showSpinner = false;
            },
            (err: any) => {
              this.showSpinner = false;
            }
          )
      );
    }
    if (
      this.selectedFieldList == null &&
      this.combinedQuestionList[this.pageno].formFieldType == "CHECKBOX"
    ) {
      let dropdownData: any[] = [];
      if (this.combinedQuestionList[this.pageno].info == "STATIC") {
        this.customConfigData[
          this.combinedQuestionList[this.pageno].identifier
        ].forEach((val: any) => {
          dropdownData.push({ value: val.toString(), label: val.toString() });
        });
      } else {
        if (
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.length > 0
        ) {
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.forEach((val: any) => {
            dropdownData.push({ value: val.toString(), label: val.toString() });
          });
        }
      }
      this.selectedFieldList = dropdownData;
    }
    if (this.combinedQuestionList[this.pageno].formFieldType == "RADIOBUTTON") {
      this.customConfigData[this.combinedQuestionList[this.pageno].identifier] =
        this.customConfigData[
          this.combinedQuestionList[this.pageno].identifier
        ].toString();
    }
    if (this.combinedQuestionList[this.pageno].type === "TEMPLATED") {
      this.incentiveAndPayoutQuestions = [
        this.combinedQuestionList[this.pageno],
        this.combinedQuestionList[this.pageno + 1],
        this.combinedQuestionList[this.pageno + 2],
        this.combinedQuestionList[this.pageno + 3],
      ];
      this.questionType = "GROUP";
      return;
    }
    if (this.combinedQuestionList[this.pageno].info === "BUDGET_CAP") {
      if (
        this.combinedQuestionList[this.pageno].identifier ===
        "BUDGETCAP_REGIONAL"
      ) {
        this.questionType = this.combinedQuestionList[this.pageno].identifier;
      } else {
        this.questionType = "BUDGET-TEXT";
      }
      return;
    }
    if (
      this.combinedQuestionList[this.pageno].identifier ==
      "contraFundingApproverEmails"
    ) {
      this.passiveRecipientEmailVal = "contraFundingPassiveRecipientEmails";
      this.passiveRecipientEmailData =
        this.customConfigData["contraFundingPassiveRecipientEmails"];
    }
    if (
      this.combinedQuestionList[this.pageno].identifier ==
      "productApproverEmails"
    ) {
      this.passiveRecipientEmailVal = "productPassiveRecipientEmails";
      this.passiveRecipientEmailData =
        this.customConfigData["productPassiveRecipientEmails"];
    }
    if (
      this.combinedQuestionList[this.pageno].identifier ==
      "challengeApproverEmails"
    ) {
      this.passiveRecipientEmailVal = "challengePassiveRecipientEmails";
      this.passiveRecipientEmailData =
        this.customConfigData["challengePassiveRecipientEmails"];
    }
    this.questionType = this.combinedQuestionList[this.pageno].formFieldType;
  }

  moveToNextPage(pageno: any, pageName?: any, event?: any) {
    if (pageName == "criteriaGroup") {
      this.setCriteriaGroup(event);
    }
    if (pageName == "budget-single") {
      this.setBudgetNonRegionGroup();
    }
    if (pageName == "budget-group") {
      this.setBudgetRegionGroup();
    }
    if (
      this.combinedQuestionList[this.pageno].formFieldType == "TEXTAREA_LIST"
    ) {
      if (
        this.combinedQuestionList[this.pageno].identifier == "approverEmails" ||
        this.combinedQuestionList[this.pageno].identifier ==
          "contraFundingApproverEmails" ||
        this.combinedQuestionList[this.pageno].identifier ==
          "productApproverEmails" ||
        this.combinedQuestionList[this.pageno].identifier ==
          "challengeApproverEmails"
      ) {
        this.customConfigData[this.passiveRecipientEmailVal] =
          this.passiveRecipientEmailData || [];
        this.setEmailData();
        this.setPassiveEmailData();
        if (
          !this.combinedQuestionList[this.pageno].emailValidationSuccess ||
          this.passiveEmailValidation
        ) {
          return;
        }
      } else {
        this.setCountryValidatedData();
        if (!this.inEligibleCountryValidated) {
          return;
        }
      }
    }
    //console.log(this.customConfigData);
    if (
      this.combinedQuestionList[this.pageno].type === "TEMPLATED" &&
      this.combinedQuestionList[this.pageno + 1].type === "TEMPLATED" &&
      this.combinedQuestionList[this.pageno + 3].type === "TEMPLATED"
    ) {
      this.pageno = pageno + 4;
    } else {
      this.pageno = pageno + 1;
    }
    this.initialAnsweredQues =
      this.pageno > this.initialAnsweredQues
        ? this.pageno
        : this.initialAnsweredQues;
    if (this.pageno === this.combinedQuestionList.length) {
      this.getQuestionContents(true);
      return;
    }
    if (this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED") {
      this.dynamicQuestionIndex =
        this.customConfigData.challengeCriteria.criterias.findIndex(
          (criteria: any) => {
            if (criteria.type != "GROUP") {
              return (
                criteria.questionInfo.questionIdentifier ===
                this.combinedQuestionList[this.pageno].identifier
              );
            }
          }
        );
    }
    if (
      this.combinedQuestionList[this.pageno].info === "STATIC" &&
      this.combinedQuestionList[this.pageno].identifier === "acronym"
    ) {
      if (this.customConfigData.acronym == null) {
        let challengeName = "";
        this.customConfigData.name
          .split(" ")
          .filter((e: any) => e.trim())
          .forEach((x: any) => {
            challengeName += x.charAt(0).toUpperCase();
          });
        this.customConfigData.acronym =
          "SC-" +
          challengeName +
          "-" +
          this.customConfigData.quarter.slice(-1) +
          this.customConfigData.fiscalYear.slice(-2);
      }
    }
    this.getQuestionContents();
    setTimeout(() => {
      if (this.promotionEditOrCopy) {
        this.progressVal = Math.ceil(
          (this.combinedQuestionList.length /
            this.combinedQuestionList.length) *
            100
        );
      } else {
        this.progressVal = Math.ceil(
          (this.initialAnsweredQues / (this.combinedQuestionList.length - 1)) *
            100
        );
      }
    }, 0);
  }

  moveToPreviousPage(pageno: any, inputStatus: any, pageName?: any, event?: any) {
    if (pageName == "criteriaGroup") {
      this.setCriteriaGroup(event);
    }
    if (this.questionType === "finalReview") {
      this.pageno = pageno - 1;
      this.getQuestionContents();
      return;
    }
    if (this.initialAnsweredQues === pageno && !inputStatus) {
      this.initialAnsweredQues = this.initialAnsweredQues + 1;
    }
    if (
      this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED" &&
      this.combinedQuestionList[this.pageno - 1].type === "TEMPLATED" &&
      this.combinedQuestionList[this.pageno - 3].type === "TEMPLATED"
    ) {
      this.pageno = pageno - 4;
    } else {
      this.pageno = pageno - 1;
    }
    if (this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED") {
      this.dynamicQuestionIndex =
        this.customConfigData.challengeCriteria.criterias.findIndex(
          (criteria: any) => {
            if (criteria.type != "GROUP") {
              return (
                criteria.questionInfo.questionIdentifier ===
                this.combinedQuestionList[this.pageno].identifier
              );
            }
          }
        );
    }
    this.getQuestionContents();
    setTimeout(() => {
      if (this.promotionEditOrCopy) {
        this.progressVal = Math.ceil(
          (this.combinedQuestionList.length /
            this.combinedQuestionList.length) *
            100
        );
      } else {
        this.progressVal = Math.ceil(
          (this.initialAnsweredQues / (this.combinedQuestionList.length - 1)) *
            100
        );
      }
    }, 0);
  }

  upload() {
    const fileInputEl = document.getElementById("getFile");
    if (fileInputEl) { fileInputEl.click(); }
  }

  getFile(eve: any) {
    //console.log(eve);
    let data: any;
    const target: DataTransfer = <DataTransfer>eve.target;
    if (target.files.length !== 1) {
      throw new Error("Cannot use multiple files");
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      //adding filename to json
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].uploadedFileName = target.files[0].name;

      /* save data */
      data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      //console.log(data); // Data will be logged in array format containing objects
      this.fileInput.nativeElement.value = "";
      this.setDataInDropDown(data);
    };
  }

  setDataInDropDown(data: any) {
    if (!data.length) {
      this.popupMessageService.showError(
        "The uploaded file has no data rows",
        "error"
      );
      return;
    }
    let columnName = Object.keys(data[0])[0];
    let dropdownData: any[] = [];
    let selectedValData: any[] = [];
    data.forEach((val: any) => {
      dropdownData.push({
        value: val[columnName].toString(),
        label: val[columnName].toString(),
      });
      selectedValData.push(val[columnName].toString());
    });
    this.selectedFieldList = dropdownData;
    this.customConfigData.challengeCriteria.criterias[
      this.dynamicQuestionIndex
    ].acceptedValues = selectedValData;
    let fieldType = this.combinedQuestionList[this.pageno].identifier;
    this.possibleValuesList[fieldType] = dropdownData;
  }

  navigateToSelectedQuestion(questionList: any) {
    this.pageno = this.combinedQuestionList.indexOf(questionList);
    if (this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED") {
      this.dynamicQuestionIndex =
        this.customConfigData.challengeCriteria.criterias.findIndex(
          (criteria: any) => {
            if (criteria.type != "GROUP") {
              return (
                criteria.questionInfo.questionIdentifier ===
                this.combinedQuestionList[this.pageno].identifier
              );
            }
          }
        );
    }
    this.getQuestionContents();
  }

  removeSelectedCountryLists() {
    let includeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge: any) => {
          return challenge.field == "COUNTRY_INCLUDE";
        }
      );
    if (
      includeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[includeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues = [];
    }
    let excludeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge: any) => {
          return challenge.field == "COUNTRY_EXCLUDE";
        }
      );
    if (
      excludeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[excludeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues = [];
    }
  }

  setCountryIncludeExcludeData() {
    let dropdownData: any[] = [];
    this.possibleValuesList.REGION_COUNTRY_MAPPING.forEach((regionData: any) => {
      this.customConfigData["regions"].forEach((region: any) => {
        if (region === regionData.value) {
          dropdownData = [...dropdownData, ...regionData.possibleValues];
        }
      });
    });
    let includeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge: any) => {
          return challenge.field == "COUNTRY_INCLUDE";
        }
      );
    if (
      includeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[includeIndex]
        .acceptedValues.length > 0
    ) {
      let countryListData: any[] = [];
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues.forEach((val: any) => {
        dropdownData.forEach((country: any) => {
          if ((val.value || val) === country.value) {
            countryListData.push(country);
          }
        });
      });
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues = countryListData;
    }
    let excludeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge: any) => {
          return challenge.field == "COUNTRY_EXCLUDE";
        }
      );
    if (
      excludeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[excludeIndex]
        .acceptedValues.length > 0
    ) {
      let countryListData: any[] = [];
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues.forEach((val: any) => {
        dropdownData.forEach((country: any) => {
          if ((val.value || val) === country.value) {
            countryListData.push(country);
          }
        });
      });
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues = countryListData;
    }
  }

  setIncludeAndExcludeCountryData() {
    let includeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge: any) => {
          return challenge.field == "COUNTRY_INCLUDE";
        }
      );
    if (
      includeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[includeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues = this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues.map((x: any) => x.value);
    }
    let excludeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge: any) => {
          return challenge.field == "COUNTRY_EXCLUDE";
        }
      );
    if (
      excludeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[excludeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues = this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues.map((x: any) => x.value);
    }
  }

  submitSalesChallenge() {
    this.setIncludeAndExcludeCountryData();
    this.subs.push(
      this.createPromotionService
        .submitCustomSalesChallenge(this.customConfigData)
        .subscribe(
          (response: any) => {
            //console.log(response);
            if (response != "") {
              this.promoSubmittedStatusEvent.emit(true);
              this.popupMessageService.showSuccess(
                "Created Challenge Successfully",
                "success"
              );
              this.disableSaveButton = false;
            }
          },
          (err: any) => {
            if (err !== null) {
              this.popupMessageService.showError(
                "Something went wrong",
                "error"
              );
              this.disableSaveButton = false;
            }
          }
        )
    );
  }

  createPromoFormSubmit(submissionType: any) {
    this.disableSaveButton = true;
    // if(submissionType == 'SUBMIT') {
    //   this.customConfigData.status =  'PENDING_APPROVAL';
    // }
    if (
      this.budgetCapAmtMain[
        this.combinedQuestionList[this.pageno - 1].identifier
      ] != null
    ) {
      let index = this.customConfigData.budgetCaps.findIndex((budget: any) => {
        return (
          budget.customBudgetCapType ==
          this.combinedQuestionList[this.pageno - 1].identifier
        );
      });
      if (index > -1) {
        this.customConfigData.budgetCaps[index].amount =
          this.budgetCapAmtMain[
            this.combinedQuestionList[this.pageno - 1].identifier
          ] || null;
      } else {
        this.customConfigData.budgetCaps.push({
          amount:
            this.budgetCapAmtMain[
              this.combinedQuestionList[this.pageno - 1].identifier
            ] || null,
          customBudgetCapType:
            this.combinedQuestionList[this.pageno - 1].identifier,
        });
      }
    }
    this.customConfigData["autoDistPointsToCompanyOverride"] =
      this.customConfigData["autoDistPointsToCompanyOverride"] === "true"
        ? true
        : false;
    if (submissionType == "SUBMIT") {
      const dialogRef = this.dialog.open(ConfirmationDialogSubmitPromo, {
        width: "514px",
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result.event) {
          this.submitSalesChallenge();
        } else {
          //console.log(this.customConfigData);
          // this.customConfigData.status=prevStatus;
        }
      });
    } else {
      this.submitSalesChallenge();
    }
  }

  setCriteriaGroup(event: any) {
    this.customConfigData.challengeCriteria.criterias = this.customConfigData.challengeCriteria.criterias.map((obj: any) => {
      if (obj.type == "GROUP") {
        return event;
      } else {
        return obj;
      }
    });
  }

  setDateValues() {
    if (
      this.combinedQuestionList[this.pageno].identifier == "fiscalYear" ||
      this.combinedQuestionList[this.pageno].identifier == "quarter"
    ) {
      this.possibleValuesList.fiscalYear.forEach((data: any) => {
        if (data.value == this.customConfigData.fiscalYear) {
          data.possibleValues.forEach((quarterData: any) => {
            if (quarterData.value == this.customConfigData.quarter) {
              quarterData.possibleValues.filter((dateData: any) => {
                if (dateData.label == "Start Date") {
                  this.customConfigData["startDate"] = dateData.value;
                }
                if (dateData.label == "End Date") {
                  this.customConfigData["endDate"] = dateData.value;
                }
              });
            }
          });
        }
      });
      let challengeName = "";
      this.customConfigData.name
        .split(" ")
        .filter((e: any) => e.trim())
        .forEach((x: any) => {
          challengeName += x.charAt(0).toUpperCase();
        });
      this.customConfigData.acronym =
        "SC-" +
        challengeName +
        "-" +
        (this.customConfigData.quarter
          ? this.customConfigData.quarter.slice(-1)
          : "") +
        (this.customConfigData.fiscalYear
          ? this.customConfigData.fiscalYear.slice(-2)
          : "");
      let quickClaimingDeadlineDate = new Date(
        this.customConfigData["endDate"]
      );
      quickClaimingDeadlineDate.setDate(
        quickClaimingDeadlineDate.getDate() + 60
      );
      this.customConfigData["quickClaimingDeadline"] =
        quickClaimingDeadlineDate;
      let popClaimingDeadlineDate = new Date(this.customConfigData["endDate"]);
      popClaimingDeadlineDate.setDate(popClaimingDeadlineDate.getDate() + 30);
      this.customConfigData["popClaimingDeadline"] = popClaimingDeadlineDate;
    }
  }

  onEndDateChange(event: any) {
    this.customConfigData["endDate"] = event;
    let quickClaimingDeadlineDate = new Date(this.customConfigData["endDate"]);
    quickClaimingDeadlineDate.setDate(quickClaimingDeadlineDate.getDate() + 60);
    this.customConfigData["quickClaimingDeadline"] = quickClaimingDeadlineDate;
    let popClaimingDeadlineDate = new Date(this.customConfigData["endDate"]);
    popClaimingDeadlineDate.setDate(popClaimingDeadlineDate.getDate() + 30);
    this.customConfigData["popClaimingDeadline"] = popClaimingDeadlineDate;
  }

  setAcronymOnNameChange() {
    if (this.combinedQuestionList[this.pageno].identifier == "name") {
      let challengeName = "";
      this.customConfigData.name
        .split(" ")
        .filter((e: any) => e.trim())
        .forEach((x: any) => {
          challengeName += x.charAt(0).toUpperCase();
        });
      this.customConfigData.acronym =
        "SC-" +
        challengeName +
        "-" +
        (this.customConfigData.quarter
          ? this.customConfigData.quarter.slice(-1)
          : "") +
        (this.customConfigData.fiscalYear
          ? this.customConfigData.fiscalYear.slice(-2)
          : "");
    }
  }

  setBudgetNonRegionGroup() {
    let index = this.customConfigData.budgetCaps.findIndex((budget: any) => {
      return (
        budget.customBudgetCapType ==
        this.combinedQuestionList[this.pageno].identifier
      );
    });
    if (index > -1) {
      this.customConfigData.budgetCaps[index].amount =
        this.budgetCapAmtMain[
          this.combinedQuestionList[this.pageno].identifier
        ] || null;
    } else {
      this.customConfigData.budgetCaps.push({
        amount:
          this.budgetCapAmtMain[
            this.combinedQuestionList[this.pageno].identifier
          ] || null,
        customBudgetCapType: this.combinedQuestionList[this.pageno].identifier,
      });
    }
  }

  setBudgetRegionGroup() {
    Object.entries(this.budgetCapAmtForRegions).forEach(([key, value]: [string, any]) => {
      let index = this.customConfigData.budgetCaps.findIndex((budget: any) => {
        if (budget.hasOwnProperty("region")) {
          return budget.region == key;
        }
      });
      if (index > -1) {
        this.customConfigData.budgetCaps[index].amount = value || null;
      } else {
        this.customConfigData.budgetCaps.push({
          amount: value || null,
          customBudgetCapType: "BUDGETCAP_REGIONAL",
          region: key,
        });
      }
    });
  }

  setCriteriaData(criteria: any, value: any) {
    if (value == "") {
      criteria.acceptedValues.length = 0;
      return;
    }
    if (criteria.acceptedValues.length) {
      criteria.acceptedValues[0] = value;
    } else {
      criteria.acceptedValues.push(value);
    }
  }

  setEmailData() {
    let emailValues =
      typeof this.customConfigData[
        this.combinedQuestionList[this.pageno].identifier
      ] == "object"
        ? (this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ] = this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ]
            .join(",")
            .split(","))
        : this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ].split(/[,;^\s*$]+/);
    this.combinedQuestionList[this.pageno].emailValidationSuccess =
      this.verifyEmailValues(emailValues);
    if (this.combinedQuestionList[this.pageno].emailValidationSuccess) {
      this.customConfigData[this.combinedQuestionList[this.pageno].identifier] =
        [];
      emailValues.forEach(
        (emailID: any) =>
          emailID &&
          this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ].push(emailID)
      );
    }
    //console.log(this.customConfigData[this.combinedQuestionList[this.pageno].identifier])
  }

  setCountryValidatedData() {
    if (
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues == "" &&
      !this.combinedQuestionList[this.pageno].isRequired
    ) {
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues = [];
      this.inEligibleCountryValidated = true;
      return;
    }
    let ineligibleCountries =
      typeof this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues == "object"
        ? (this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues = this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues
            .join(",")
            .split(","))
        : this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.split(/[,;^\s*$]+/);
    this.inEligibleCountryValidated =
      this.verifyCountryValues(ineligibleCountries);
    if (this.inEligibleCountryValidated) {
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues = [];
      ineligibleCountries.forEach(
        (country: any) =>
          country &&
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.push(country)
      );
    }
    //console.log(this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex].acceptedValues)
  }

  verifyEmailValues(emailValues: any) {
    let emailVerificationStatus: any;
    let regex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    emailVerificationStatus = emailValues.every((email: any) => {
      return regex.test(email);
    });
    return emailVerificationStatus;
  }

  verifyCountryValues(countryList: any) {
    let countryVerificationStatus: any;
    let regex = /[A-Za-z]/;
    countryList.forEach((email: any) => {
      if (regex.test(email)) {
        countryVerificationStatus = true;
      } else {
        countryVerificationStatus = false;
      }
    });
    return countryVerificationStatus;
  }

  getIncentiveAndPayoutData() {
    let incentiveAndPayout =
      this.customConfigData.challengeCriteria.criterias.filter((obj: any) => {
        if (obj.type == "GROUP") {
          return obj;
        }
      });
    return incentiveAndPayout[0];
  }

  checkSpecializationValue() {
    let returnVal = false;
    if (this.combinedQuestionList[this.pageno].identifier == "BEGEOID") {
      this.customConfigData.challengeCriteria.criterias.forEach((criteria: any) => {
        if (criteria.field == "PARTNER_SPECIALIZATION") {
          const val = criteria.acceptedValues[0];
          if (
            !!val &&
            typeof val === "string" &&
            val.toLowerCase() != "all"
          ) {
            returnVal = true;
          } else {
            returnVal = false;
          }
        }
      });
    }
    return returnVal;
  }

  downloadExcelModalOpen = false;
  downloadExcelType = '';

  showDownloadExcelFormatDialog(identifier: any): void {
    this.downloadExcelType = identifier;
    this.downloadExcelModalOpen = true;
  }

  closeDownloadExcelModal(): void {
    this.downloadExcelModalOpen = false;
  }

  setPassiveEmailData() {
    let emailValues: any;
    let regex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    if (
      this.customConfigData[this.passiveRecipientEmailVal] == null ||
      this.customConfigData[this.passiveRecipientEmailVal].length === 0
    ) {
      this.passiveEmailValidation = false;
      return;
    }
    typeof this.customConfigData[this.passiveRecipientEmailVal] == "object"
      ? (emailValues = this.customConfigData[this.passiveRecipientEmailVal])
      : (emailValues =
          this.customConfigData[this.passiveRecipientEmailVal].split(
            /[,;^\s*$]+/
          ));
    let passiveEmailTest = emailValues.every((email: any) => {
      return regex.test(email);
    });
    if (passiveEmailTest) {
      this.passiveEmailValidation = false;
      this.customConfigData[this.passiveRecipientEmailVal] = [];
      emailValues.forEach(
        (emailID: any) =>
          emailID &&
          this.customConfigData[this.passiveRecipientEmailVal].push(emailID)
      );
    } else {
      this.passiveEmailValidation = true;
    }
  }

  getSelectedCheckboxItems(): any[] {
    if (!this.selectedFieldList || !this.customConfigData) {
      return [];
    }
    const criteria = this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex];
    if (!criteria || !criteria.acceptedValues || criteria.acceptedValues.length === 0) {
      return [];
    }
    return this.selectedFieldList.filter((item: any) => criteria.acceptedValues.indexOf(item.value) !== -1);
  }

  getRegionSelectedItems(): any[] {
    const identifier = this.combinedQuestionList[this.pageno].identifier;
    const values = this.customConfigData[identifier];
    if (!this.selectedFieldList || !values || values.length === 0) {
      return [];
    }
    return this.selectedFieldList.filter((item: any) => values.indexOf(item.value) !== -1);
  }

  onRegionMultiChange(selectedItems: any[]): void {
    const identifier = this.combinedQuestionList[this.pageno].identifier;
    const previousValues = this.customConfigData[identifier];
    const newValues = selectedItems.map((item: any) => item.value);
    const wasDeselected = previousValues && newValues.length < previousValues.length;
    this.customConfigData[identifier] = newValues;
    if (wasDeselected &&
        this.combinedQuestionList[this.pageno].formFieldType === 'CHECKBOX' &&
        identifier === 'regions') {
      this.removeSelectedCountryLists();
    }
    this.updateBudgetRegionSelection();
  }

  getCountrySelectedItems(): any[] {
    if (!this.selectedFieldList || !this.customConfigData) {
      return [];
    }
    const criteria = this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex];
    if (!criteria || !criteria.acceptedValues || criteria.acceptedValues.length === 0) {
      return [];
    }
    const firstVal = criteria.acceptedValues[0];
    if (typeof firstVal === 'object' && firstVal !== null) {
      return criteria.acceptedValues;
    }
    return this.selectedFieldList.filter((item: any) => criteria.acceptedValues.indexOf(item.value) !== -1);
  }

  onCountryMultiChange(selectedItems: any[]): void {
    this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex].acceptedValues = selectedItems;
  }

  onCheckboxMultiChange(selectedItems: any[]): void {
    const criteria = this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex];
    if (this.combinedQuestionList[this.pageno].identifier === 'TRAINING_ACTIVITY') {
      const noneItem = selectedItems.find((item: any) => item.label === 'NONE');
      const hadNone = criteria.acceptedValues.indexOf('NONE') !== -1;
      if (noneItem && !hadNone) {
        criteria.acceptedValues = ['NONE'];
        this.customConfigData['activityChallengeCompletionIsRequired'] = false;
        return;
      }
      if (noneItem && hadNone && selectedItems.length > 1) {
        criteria.acceptedValues = selectedItems.filter((item: any) => item.label !== 'NONE').map((item: any) => item.value);
        return;
      }
    }
    criteria.acceptedValues = selectedItems.map((item: any) => item.value);
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }
}
